/**
 * Common functionality for the nav pane for sections where new objects should
 * be created on the edit tab.
 */

import conductor from 'scoreboard/components/conductor'

import globals from 'scoreboard/components/globals'
import guard from 'scoreboard/components/unsaved/guard'
import sections from 'scoreboard/components/sections'

var NewTab = {

	events: {
		'click .new': 'addObject',
		// handle button shown when there are no objects in the org yet
		'click .create-first': 'addFirstObject'
	},

	// navigates to the create object view
	addObject: function () {
		guard.conditionallyRun(function() {
			this.toggleEditViewState(true, { isNew: true })
			var url
			if (conductor.id()) {
				url = sections.toUrl(this.section) + '/' + conductor.id() + '/new'
			} else {
				// this is for when we're creating the first folder in an org
				url = 'organizations/' + globals.orgId + '/' + sections.toUrl(this.section) + '/new'
			}
			conductor.navigate(url, { trigger: true })
		}.bind(this))
	},

	// navigates to the create object view that's appropriate for empty orgs
	addFirstObject: function () {
		conductor.navigate('organizations/' + globals.orgId + '/' + sections.toUrl(this.section) + '/new', { trigger: true })
	}

}

export default NewTab

NewTab.__filename__ = 'components/new-tab.js'
